"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inspectFaServiceDefinition = void 0;
const v1_1 = require("./v1");
const render_1 = require("./render");
__exportStar(require("./types"), exports);
__exportStar(require("./CacheMonitoring"), exports);
__exportStar(require("./utils/createInspectFetchJson"), exports);
__exportStar(require("./type-check"), exports);
exports.inspectFaServiceDefinition = {
    id: 'inspect-fa-service',
    dependencies: {
        featureServices: {
            'layer-manager': '2.7.0',
            's2:logger': '1.0.0',
            'featureapp-service': '1.0.0',
        },
    },
    create: (env) => {
        const logger = env.featureServices['s2:logger'] || console;
        const service = new v1_1.InspectFaServiceImpl(logger);
        const fa = env.featureServices['featureapp-service'].featureAppConfigurations['inspect-fa'];
        if (!fa) {
            logger.error('inspect-fa is not defined');
        }
        return {
            '1.2.0': (consumerId, name) => ({
                unbind: () => {
                    service.removeCacheMonitoring(consumerId);
                },
                featureService: {
                    initialize: (options) => {
                        service.initialize(options);
                    },
                    get mocksServerConfig() {
                        return service.mocksServerConfig;
                    },
                    registerInstanceByFa: (inspector, version) => {
                        return service.registerInstanceByFa(consumerId, name, inspector, version);
                    },
                    get integrator() {
                        return service.integrator;
                    },
                    addCacheMonitoring(monitoring) {
                        return service.addCacheMonitoring(consumerId, name, monitoring);
                    },
                    get cacheMonitoring() {
                        return service.monitoring;
                    },
                    unregisterInstanceByFa: () => {
                        return service.unregisterInstance(consumerId);
                    },
                    getFaInstances: () => {
                        return service.getFaInstances();
                    },
                    getFaInstancesByName: (aname) => {
                        return service.getFaInstancesByName(aname);
                    },
                    setMocks(mockIds, environment) {
                        service.setMocks(mockIds, environment);
                    },
                    get mockSettings() {
                        return service.mockSettings;
                    },
                    subscribe: (cb) => {
                        return service.subscribe(cb);
                    },
                    get enabledMocks() {
                        return service.enabledMocks;
                    },
                    get enabledLogger() {
                        return service.enabledLogger;
                    },
                    getFeatureServiceLoggerRef(name) {
                        return service.getFeatureServiceLoggerRef(name);
                    },
                    setLogLevel(aname, aconsumerId, logLevel) {
                        service.setLogLevel(aname, aconsumerId, logLevel);
                    },
                    openInspectorLayer: () => {
                        if (!fa) {
                            return;
                        }
                        return env.featureServices['layer-manager'].openFocusLayer((0, render_1.render)(fa), {}, { size: "C" /* FocusLayerSizeV2.C */, userCloseable: true });
                    },
                },
            }),
        };
    },
};
//# sourceMappingURL=index.js.map